module.exports = {"screenLoader.general":"Prebieha načítanie sekcie obecné..."}